<template>
  <div>
    <header-page :namePage="'Rating Setting'" />
    <div class="content">
      <base-table
        :head="[$t('admin.ratingTableName'), $t('admin.ratingTableRating')]"
        :columnTemplates="'1fr 120px'"
      >
        <base-table-row
          v-for="tcm in tcmList"
          :key="tcm.id"
          :columnTemplates="'1fr 120px'"
        >
          <base-table-column>
            {{ tcm.full_name }}
          </base-table-column>
          <base-table-column>
            <input
              type="number"
              :value="tcm._edit"
              min="0"
              step="1"
              @input="onInput($event, tcm)"
              @keydown.enter="onSave(tcm)"
              @blur="onSave(tcm)"
              class="rating-input"
              :disabled="isLoading"
            />
          </base-table-column>
        </base-table-row>
      </base-table>
    </div>
  </div>
</template>

<script>
import BaseTable from '@/components/UI/Table/Table.vue';
import BaseTableRow from '@/components/UI/Table/TableRow.vue';
import BaseTableColumn from '@/components/UI/Table/TableColumn.vue';
import apiAdmin from "@/api/admin";

export default {
  components: {
    BaseTable,
    BaseTableRow,
    BaseTableColumn,
  },
  data() {
    return {
      tcmList: [],
      currentSegment: null,
      isSavingIds: new Set(),
      isLoading: false,
    };
  },
  created() {
    this.currentSegment = this.$store.state.user.segment.id;
    this.fetchTcmList();
  },
  methods: {
    async fetchTcmList() {
      try {
        const data = await apiAdmin.getMimkList(this.currentSegment);
        this.tcmList = data.map(tcm => ({
          ...tcm,
          _edit: tcm.rating,
        }));
        this.sortList();
      } catch (err) {
        console.error('Ошибка загрузки списка:', err);
      }
    },
    onInput(event, tcm) {
      let val = parseInt(event.target.value, 10);
      if (isNaN(val) || val < 0) val = 0;
      tcm._edit = val;
    },

    async onSave(tcm) {
      if (tcm.rating === tcm._edit) return;
      if (this.isSavingIds.has(tcm.mimk_id)) return;
      this.isLoading = true
      this.isSavingIds.add(tcm.mimk_id);
      try {
        const updated = await apiAdmin.updateMimkRating(tcm.mimk_id, tcm._edit, this.currentSegment);
        Object.assign(tcm, updated);
        tcm._edit = tcm.rating;
        this.sortList();
      } catch {
        tcm._edit = tcm.rating;
      } finally {
        this.isSavingIds.delete(tcm.mimk_id);
        this.isLoading = false
      }
    },

    sortList() {
      this.tcmList.sort((a, b) => b.rating - a.rating);
    },
  },
};
</script>

<style lang="scss" scoped>
.rating-input {
  width: 60px;
  padding: 4px 8px;
  font-size: 16px;
}
</style>
